import { render, staticRenderFns } from "./ProntuarioDadosPessoais.vue?vue&type=template&id=e70ede96&"
import script from "./ProntuarioDadosPessoais.vue?vue&type=script&lang=js&"
export * from "./ProntuarioDadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioDadosPessoais.vue?vue&type=style&index=0&id=e70ede96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports